import { getClinicAuthToken } from '@/assets/js/auth'
import HttpRequest from './HttpRequest'

class ThemeProvider extends HttpRequest {
  // getAllStock (query) {
  //   this.setHeader(getBranchAuthToken())
  //   return this.get('/v1/stock/stock', { ...query })
  // }

  getColors (query) {
    this.setHeader(getClinicAuthToken())
    return this.get('/v1/color-setting', { ...query })
  }

  changeColor (id, payload) {
    this.setHeader(getClinicAuthToken())
    return this.patch(`/v1/color-setting/${id}`, payload)
  }

  // getStockPurchaseByid (id) {
  //   this.setHeader(getBranchAuthToken())
  //   return this.get(`/v1/stock/stock-purchase/${id}`)
  // }
}

export default ThemeProvider
